import api from '@swipekit/lib/api.js';

import CrudStore from '@swipekit/lib/crud-store';

let crud = new CrudStore({
	name: 'folders',
	singular: 'folder',
});

const state = {
	...crud.state,

	deleteConfirmationId: null,
};
const getters = {
	...crud.getters,

	deleteConfirmationId: function (state) {
		return state.deleteConfirmationId;
	},

	filtered: function (state) {
		let folders = JSON.parse(JSON.stringify(state.resources));

		folders = folders.sort((a, b) => {
			return a.order - b.order;
		});

		return folders;
	},
};
const actions = {
	...crud.actions,

	async getLocal(store) {
		let resources = [];
		try {
			resources = await crud.api[crud.resourceName].get('local');
		} catch (err) {
			throw err;
		}

		store.commit('SET', resources);
		return resources;
	},

	async doAction(store, obj) {
		let action = obj.action;
		let id = obj.id;
		let response = await crud.api.api.doAction(id, action);

		return response;
	},

	async fetchAndStore(store) {
		let resources = (await crud.api[crud.resourceName].fetchAndStore()) || [];

		store.commit(resources);
	},

	async afterLogin(store, pie) {
		let mode = store.rootState.config.mode;

		if (store.rootGetters['users/isAuth']) {
			if (mode === 'EXTENSION') {
				await store.dispatch('getLocal');
			} else {
				if (!pie) {
					await store.dispatch('get');
				} else {
					await store.dispatch('consumePie', pie);
				}
			}
		}
	},

	async remove(store, id) {
		let data = null;
		try {
			data = await api.folders.delete(id);
		} catch (err) {
			console.log(err);
			throw err;
		}
		if (data) {
			store.dispatch(
				'boards/consumePie',
				{
					workspace: {
						boards: data.boards,
					},
				},
				{ root: true }
			);
			store.dispatch(
				'folders/consumePie',
				{
					workspace: {
						folders: data.folders,
					},
				},
				{ root: true }
			);
			//store.commit('REMOVE', id);
			//store.commit('SET_REMOVE', id);
		}

		return data;
	},

	async setFolderEdit(store, folder) {
		store.editId = folder.id;
	},

	async setDeleteConfirmationId(store, folder) {
		if (folder) {
			store.state.deleteConfirmationId = folder.id;
		} else {
			store.state.deleteConfirmationId = null;
		}
	},

	async setOrder(store, obj) {
		const condition = await api.folders.setOrder(obj);
		if (condition) {
			let currentFolders = JSON.parse(JSON.stringify(store.state.resources));
			currentFolders = currentFolders.map((f) => {
				for (let i = 0; i < obj.folders.length; i++) {
					let newFolder = obj.folders[i];
					if (newFolder.id === f.id) {
						f.order = newFolder.order;
						break;
					}
				}

				return f;
			});

			store.state.resources.splice(
				0,
				store.state.resources.length,
				...currentFolders
			);
		}
	},

	consumePie: async (store, pie) => {
		store.commit('SET', pie.workspace.folders || []);
	},
};
const mutations = {
	...crud.mutations,
};

let store = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};

export default store;
